/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetChannelProviderRequest
 */
export interface GetChannelProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof GetChannelProviderRequest
     */
    channelProviderId: string;
}

export function GetChannelProviderRequestFromJSON(json: any): GetChannelProviderRequest {
    return GetChannelProviderRequestFromJSONTyped(json, false);
}

export function GetChannelProviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChannelProviderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channelProviderId': json['channel_provider_id'],
    };
}

export function GetChannelProviderRequestToJSON(value?: GetChannelProviderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'channel_provider_id': value.channelProviderId,
    };
}


